import { useEffect, useState } from 'react';
import { getActiveAds as fetchActiveAds } from '../../api/adApi';
import { pickRotatingAd } from '../constants/ads';

/**
 * 노출 중인 광고 목록.
 *
 * 화면마다 따로 부르면 한 페이지에서 같은 요청이 여러 번 나가고, 그사이 목록이 달라지면
 * 자리마다 다른 광고가 뜬다. 그래서 한 번만 받아 모듈에 들고 있다가 나눠 쓴다.
 * (adApi가 404면 프론트 상수 데이터로 되돌아오므로, 백엔드 배포 전에도 화면은 그대로다)
 */
let cached = null;
let inflight = null;

export function loadActiveAds() {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = fetchActiveAds()
      .then(list => { cached = Array.isArray(list) ? list : []; return cached; })
      .catch(() => { cached = []; return cached; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** 테스트에서 모듈 캐시를 비운다 */
export function resetAdsCache() {
  cached = null;
  inflight = null;
}

/** @returns {{ ads: object[], loading: boolean }} */
export function useActiveAds() {
  const [ads, setAds] = useState(cached);

  useEffect(() => {
    if (ads) return undefined;
    let alive = true;
    loadActiveAds().then(list => { if (alive) setAds(list); });
    return () => { alive = false; };
  }, [ads]);

  return { ads: ads ?? [], loading: ads === null };
}

/**
 * 이 자리에 오늘 보일 광고 하나.
 *
 * loading 동안 null을 주므로, 광고 자리를 세어 쪽수를 계산하는 화면은
 * loading이 끝난 뒤에 목록을 불러야 칸 수가 중간에 바뀌지 않는다.
 * @returns {{ ad: object|null, loading: boolean }}
 */
export function useRotatingAd(slotKey) {
  const { ads, loading } = useActiveAds();
  return { ad: loading ? null : pickRotatingAd(ads, slotKey), loading };
}
